import { render } from "./ClienteSelector.vue?vue&type=template&id=5bc8d3c0&scoped=true"
import script from "./ClienteSelector.vue?vue&type=script&lang=js"
export * from "./ClienteSelector.vue?vue&type=script&lang=js"

import "./ClienteSelector.vue?vue&type=style&index=0&id=5bc8d3c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc8d3c0"]])

export default __exports__